// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/transform/v1/transform.proto" (package "agency.transform.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * MessageTransformConfig configures cross-provider message normalization.
 *
 * @generated from protobuf message agency.transform.v1.MessageTransformConfig
 */
export interface MessageTransformConfig {
    /**
     * source_provider is the originating provider.
     *
     * @generated from protobuf field: string source_provider = 1
     */
    sourceProvider: string;
    /**
     * target_provider is the destination provider.
     *
     * @generated from protobuf field: string target_provider = 2
     */
    targetProvider: string;
    /**
     * thinking_block_policy determines thinking block handling.
     *
     * @generated from protobuf field: agency.transform.v1.ThinkingBlockPolicy thinking_block_policy = 3
     */
    thinkingBlockPolicy: ThinkingBlockPolicy;
    /**
     * normalize_tool_call_ids truncates tool call IDs to target limits.
     *
     * @generated from protobuf field: bool normalize_tool_call_ids = 4
     */
    normalizeToolCallIds: boolean;
    /**
     * synthesize_missing_tool_results creates placeholder results for orphaned calls.
     *
     * @generated from protobuf field: bool synthesize_missing_tool_results = 5
     */
    synthesizeMissingToolResults: boolean;
    /**
     * filter_error_messages removes error/aborted messages from replay.
     *
     * @generated from protobuf field: bool filter_error_messages = 6
     */
    filterErrorMessages: boolean;
    /**
     * enforce_alternating_roles ensures user/assistant alternation.
     *
     * @generated from protobuf field: bool enforce_alternating_roles = 7
     */
    enforceAlternatingRoles: boolean;
    /**
     * max_tool_call_id_length is the target provider's limit (0 = unlimited).
     *
     * @generated from protobuf field: int32 max_tool_call_id_length = 8
     */
    maxToolCallIdLength: number;
    /**
     * thinking_block_tag is the target provider's thinking tag.
     *
     * @generated from protobuf field: string thinking_block_tag = 9
     */
    thinkingBlockTag: string;
    /**
     * strip_tool_calls_from_content removes tool call JSON from text content.
     *
     * @generated from protobuf field: bool strip_tool_calls_from_content = 10
     */
    stripToolCallsFromContent: boolean;
}
/**
 * ContextTransformConfig configures context window management.
 *
 * @generated from protobuf message agency.transform.v1.ContextTransformConfig
 */
export interface ContextTransformConfig {
    /**
     * strategy defines the truncation strategy.
     *
     * @generated from protobuf field: agency.transform.v1.TruncationStrategy strategy = 1
     */
    strategy: TruncationStrategy;
    /**
     * window_limit is the maximum context tokens.
     *
     * @generated from protobuf field: int32 window_limit = 2
     */
    windowLimit: number;
    /**
     * preserve_recent_count preserves the N most recent messages.
     *
     * @generated from protobuf field: int32 preserve_recent_count = 3
     */
    preserveRecentCount: number;
    /**
     * preserve_system_prompt always keeps the system prompt.
     *
     * @generated from protobuf field: bool preserve_system_prompt = 4
     */
    preserveSystemPrompt: boolean;
    /**
     * summarize_truncated generates summaries of truncated content.
     *
     * @generated from protobuf field: bool summarize_truncated = 5
     */
    summarizeTruncated: boolean;
    /**
     * summary_max_tokens is the maximum tokens for summarization.
     *
     * @generated from protobuf field: int32 summary_max_tokens = 6
     */
    summaryMaxTokens: number;
}
/**
 * TransformResult reports transformation outcome.
 *
 * @generated from protobuf message agency.transform.v1.TransformResult
 */
export interface TransformResult {
    /**
     * success indicates if transformation succeeded.
     *
     * @generated from protobuf field: bool success = 1
     */
    success: boolean;
    /**
     * messages_transformed is the count of transformed messages.
     *
     * @generated from protobuf field: int32 messages_transformed = 2
     */
    messagesTransformed: number;
    /**
     * messages_dropped is the count of dropped messages.
     *
     * @generated from protobuf field: int32 messages_dropped = 3
     */
    messagesDropped: number;
    /**
     * messages_synthesized is the count of synthesized messages.
     *
     * @generated from protobuf field: int32 messages_synthesized = 4
     */
    messagesSynthesized: number;
    /**
     * tokens_saved is the estimated token reduction.
     *
     * @generated from protobuf field: int32 tokens_saved = 5
     */
    tokensSaved: number;
    /**
     * warnings are non-fatal transformation warnings.
     *
     * @generated from protobuf field: repeated string warnings = 6
     */
    warnings: string[];
    /**
     * errors are transformation errors.
     *
     * @generated from protobuf field: repeated string errors = 7
     */
    errors: string[];
}
/**
 * ThinkingBlockPolicy defines how thinking blocks are handled.
 *
 * @generated from protobuf enum agency.transform.v1.ThinkingBlockPolicy
 */
export enum ThinkingBlockPolicy {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: THINKING_BLOCK_POLICY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * PRESERVE keeps thinking blocks unchanged.
     *
     * @generated from protobuf enum value: THINKING_BLOCK_POLICY_PRESERVE = 1;
     */
    PRESERVE = 1,
    /**
     * STRIP removes thinking blocks entirely.
     *
     * @generated from protobuf enum value: THINKING_BLOCK_POLICY_STRIP = 2;
     */
    STRIP = 2,
    /**
     * REDACT replaces thinking content with placeholder.
     *
     * @generated from protobuf enum value: THINKING_BLOCK_POLICY_REDACT = 3;
     */
    REDACT = 3,
    /**
     * SUMMARIZE condenses thinking to brief summary.
     *
     * @generated from protobuf enum value: THINKING_BLOCK_POLICY_SUMMARIZE = 4;
     */
    SUMMARIZE = 4
}
/**
 * TruncationStrategy defines how context is reduced.
 *
 * @generated from protobuf enum agency.transform.v1.TruncationStrategy
 */
export enum TruncationStrategy {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: TRUNCATION_STRATEGY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * DROP_OLDEST removes oldest messages first.
     *
     * @generated from protobuf enum value: TRUNCATION_STRATEGY_DROP_OLDEST = 1;
     */
    DROP_OLDEST = 1,
    /**
     * DROP_MIDDLE preserves beginning and end, drops middle.
     *
     * @generated from protobuf enum value: TRUNCATION_STRATEGY_DROP_MIDDLE = 2;
     */
    DROP_MIDDLE = 2,
    /**
     * SUMMARIZE_OLDEST summarizes old messages to save tokens.
     *
     * @generated from protobuf enum value: TRUNCATION_STRATEGY_SUMMARIZE_OLDEST = 3;
     */
    SUMMARIZE_OLDEST = 3,
    /**
     * ROLLING_SUMMARY maintains running summary + recent messages.
     *
     * @generated from protobuf enum value: TRUNCATION_STRATEGY_ROLLING_SUMMARY = 4;
     */
    ROLLING_SUMMARY = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class MessageTransformConfig$Type extends MessageType<MessageTransformConfig> {
    constructor() {
        super("agency.transform.v1.MessageTransformConfig", [
            { no: 1, name: "source_provider", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 2, name: "target_provider", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 3, name: "thinking_block_policy", kind: "enum", T: () => ["agency.transform.v1.ThinkingBlockPolicy", ThinkingBlockPolicy, "THINKING_BLOCK_POLICY_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 4, name: "normalize_tool_call_ids", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "synthesize_missing_tool_results", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "filter_error_messages", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "enforce_alternating_roles", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "max_tool_call_id_length", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 4096, gte: 0 } } } },
            { no: 9, name: "thinking_block_tag", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64" } } } },
            { no: 10, name: "strip_tool_calls_from_content", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<MessageTransformConfig>): MessageTransformConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sourceProvider = "";
        message.targetProvider = "";
        message.thinkingBlockPolicy = 0;
        message.normalizeToolCallIds = false;
        message.synthesizeMissingToolResults = false;
        message.filterErrorMessages = false;
        message.enforceAlternatingRoles = false;
        message.maxToolCallIdLength = 0;
        message.thinkingBlockTag = "";
        message.stripToolCallsFromContent = false;
        if (value !== undefined)
            reflectionMergePartial<MessageTransformConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MessageTransformConfig): MessageTransformConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string source_provider */ 1:
                    message.sourceProvider = reader.string();
                    break;
                case /* string target_provider */ 2:
                    message.targetProvider = reader.string();
                    break;
                case /* agency.transform.v1.ThinkingBlockPolicy thinking_block_policy */ 3:
                    message.thinkingBlockPolicy = reader.int32();
                    break;
                case /* bool normalize_tool_call_ids */ 4:
                    message.normalizeToolCallIds = reader.bool();
                    break;
                case /* bool synthesize_missing_tool_results */ 5:
                    message.synthesizeMissingToolResults = reader.bool();
                    break;
                case /* bool filter_error_messages */ 6:
                    message.filterErrorMessages = reader.bool();
                    break;
                case /* bool enforce_alternating_roles */ 7:
                    message.enforceAlternatingRoles = reader.bool();
                    break;
                case /* int32 max_tool_call_id_length */ 8:
                    message.maxToolCallIdLength = reader.int32();
                    break;
                case /* string thinking_block_tag */ 9:
                    message.thinkingBlockTag = reader.string();
                    break;
                case /* bool strip_tool_calls_from_content */ 10:
                    message.stripToolCallsFromContent = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MessageTransformConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string source_provider = 1; */
        if (message.sourceProvider !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sourceProvider);
        /* string target_provider = 2; */
        if (message.targetProvider !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.targetProvider);
        /* agency.transform.v1.ThinkingBlockPolicy thinking_block_policy = 3; */
        if (message.thinkingBlockPolicy !== 0)
            writer.tag(3, WireType.Varint).int32(message.thinkingBlockPolicy);
        /* bool normalize_tool_call_ids = 4; */
        if (message.normalizeToolCallIds !== false)
            writer.tag(4, WireType.Varint).bool(message.normalizeToolCallIds);
        /* bool synthesize_missing_tool_results = 5; */
        if (message.synthesizeMissingToolResults !== false)
            writer.tag(5, WireType.Varint).bool(message.synthesizeMissingToolResults);
        /* bool filter_error_messages = 6; */
        if (message.filterErrorMessages !== false)
            writer.tag(6, WireType.Varint).bool(message.filterErrorMessages);
        /* bool enforce_alternating_roles = 7; */
        if (message.enforceAlternatingRoles !== false)
            writer.tag(7, WireType.Varint).bool(message.enforceAlternatingRoles);
        /* int32 max_tool_call_id_length = 8; */
        if (message.maxToolCallIdLength !== 0)
            writer.tag(8, WireType.Varint).int32(message.maxToolCallIdLength);
        /* string thinking_block_tag = 9; */
        if (message.thinkingBlockTag !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.thinkingBlockTag);
        /* bool strip_tool_calls_from_content = 10; */
        if (message.stripToolCallsFromContent !== false)
            writer.tag(10, WireType.Varint).bool(message.stripToolCallsFromContent);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.transform.v1.MessageTransformConfig
 */
export const MessageTransformConfig = new MessageTransformConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContextTransformConfig$Type extends MessageType<ContextTransformConfig> {
    constructor() {
        super("agency.transform.v1.ContextTransformConfig", [
            { no: 1, name: "strategy", kind: "enum", T: () => ["agency.transform.v1.TruncationStrategy", TruncationStrategy, "TRUNCATION_STRATEGY_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 2, name: "window_limit", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10000000, gte: 1 } } } },
            { no: 3, name: "preserve_recent_count", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 1000, gte: 0 } } } },
            { no: 4, name: "preserve_system_prompt", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "summarize_truncated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "summary_max_tokens", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10000, gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<ContextTransformConfig>): ContextTransformConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.strategy = 0;
        message.windowLimit = 0;
        message.preserveRecentCount = 0;
        message.preserveSystemPrompt = false;
        message.summarizeTruncated = false;
        message.summaryMaxTokens = 0;
        if (value !== undefined)
            reflectionMergePartial<ContextTransformConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ContextTransformConfig): ContextTransformConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.transform.v1.TruncationStrategy strategy */ 1:
                    message.strategy = reader.int32();
                    break;
                case /* int32 window_limit */ 2:
                    message.windowLimit = reader.int32();
                    break;
                case /* int32 preserve_recent_count */ 3:
                    message.preserveRecentCount = reader.int32();
                    break;
                case /* bool preserve_system_prompt */ 4:
                    message.preserveSystemPrompt = reader.bool();
                    break;
                case /* bool summarize_truncated */ 5:
                    message.summarizeTruncated = reader.bool();
                    break;
                case /* int32 summary_max_tokens */ 6:
                    message.summaryMaxTokens = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ContextTransformConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.transform.v1.TruncationStrategy strategy = 1; */
        if (message.strategy !== 0)
            writer.tag(1, WireType.Varint).int32(message.strategy);
        /* int32 window_limit = 2; */
        if (message.windowLimit !== 0)
            writer.tag(2, WireType.Varint).int32(message.windowLimit);
        /* int32 preserve_recent_count = 3; */
        if (message.preserveRecentCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.preserveRecentCount);
        /* bool preserve_system_prompt = 4; */
        if (message.preserveSystemPrompt !== false)
            writer.tag(4, WireType.Varint).bool(message.preserveSystemPrompt);
        /* bool summarize_truncated = 5; */
        if (message.summarizeTruncated !== false)
            writer.tag(5, WireType.Varint).bool(message.summarizeTruncated);
        /* int32 summary_max_tokens = 6; */
        if (message.summaryMaxTokens !== 0)
            writer.tag(6, WireType.Varint).int32(message.summaryMaxTokens);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.transform.v1.ContextTransformConfig
 */
export const ContextTransformConfig = new ContextTransformConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TransformResult$Type extends MessageType<TransformResult> {
    constructor() {
        super("agency.transform.v1.TransformResult", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "messages_transformed", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 3, name: "messages_dropped", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 4, name: "messages_synthesized", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 5, name: "tokens_saved", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 6, name: "warnings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "50", items: { string: { maxLen: "1024" } } } } } },
            { no: 7, name: "errors", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "50", items: { string: { maxLen: "1024" } } } } } }
        ]);
    }
    create(value?: PartialMessage<TransformResult>): TransformResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.success = false;
        message.messagesTransformed = 0;
        message.messagesDropped = 0;
        message.messagesSynthesized = 0;
        message.tokensSaved = 0;
        message.warnings = [];
        message.errors = [];
        if (value !== undefined)
            reflectionMergePartial<TransformResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TransformResult): TransformResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* int32 messages_transformed */ 2:
                    message.messagesTransformed = reader.int32();
                    break;
                case /* int32 messages_dropped */ 3:
                    message.messagesDropped = reader.int32();
                    break;
                case /* int32 messages_synthesized */ 4:
                    message.messagesSynthesized = reader.int32();
                    break;
                case /* int32 tokens_saved */ 5:
                    message.tokensSaved = reader.int32();
                    break;
                case /* repeated string warnings */ 6:
                    message.warnings.push(reader.string());
                    break;
                case /* repeated string errors */ 7:
                    message.errors.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TransformResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* int32 messages_transformed = 2; */
        if (message.messagesTransformed !== 0)
            writer.tag(2, WireType.Varint).int32(message.messagesTransformed);
        /* int32 messages_dropped = 3; */
        if (message.messagesDropped !== 0)
            writer.tag(3, WireType.Varint).int32(message.messagesDropped);
        /* int32 messages_synthesized = 4; */
        if (message.messagesSynthesized !== 0)
            writer.tag(4, WireType.Varint).int32(message.messagesSynthesized);
        /* int32 tokens_saved = 5; */
        if (message.tokensSaved !== 0)
            writer.tag(5, WireType.Varint).int32(message.tokensSaved);
        /* repeated string warnings = 6; */
        for (let i = 0; i < message.warnings.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.warnings[i]);
        /* repeated string errors = 7; */
        for (let i = 0; i < message.errors.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.errors[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.transform.v1.TransformResult
 */
export const TransformResult = new TransformResult$Type();
